import { useParams } from 'react-router'

import { useQuoteRequest } from '../quote-request/useQuoteRequest'
import { BookingPage } from './BookingPage'
import { TLBookingPageLayout } from './TLBookingPageLayout'

export const TLBookingPage = () => {
  const { quoteRequestId } = useParams()
  const quoteRequestQuery = useQuoteRequest(quoteRequestId)
  const loads = quoteRequestQuery.data ?? []

  return (
    <TLBookingPageLayout isLoading={quoteRequestQuery.isLoading}>
      <BookingPage loads={loads} />
    </TLBookingPageLayout>
  )
}
